// Multiple sections on a page (fg-faq, pi-collapsible-content) each render their own
// independent FAQPage JSON-LD block. Google and AI answer engines expect a single
// FAQPage entity per page, not one per accordion widget — so this merges every
// FAQPage block found into the first one and removes the rest. No-op if 0 or 1 found.
document.addEventListener('DOMContentLoaded', function () {
  var scripts = Array.prototype.slice.call(document.querySelectorAll('script[type="application/ld+json"]'));
  var faqScripts = [];
  var merged = { '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: [] };

  scripts.forEach(function (el) {
    var data;
    try {
      data = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }
    if (data && data['@type'] === 'FAQPage' && Array.isArray(data.mainEntity)) {
      merged.mainEntity = merged.mainEntity.concat(data.mainEntity);
      faqScripts.push(el);
    }
  });

  if (faqScripts.length > 1) {
    faqScripts.forEach(function (el, index) {
      if (index === 0) {
        el.textContent = JSON.stringify(merged);
      } else {
        el.remove();
      }
    });
  }
});
